import React, {useEffect, useRef, useState} from "react";

import signInBanner from "../../../assets/images/icons/ic-signin.svg";
import {useNavigate} from "react-router-dom";
import {RouteHelper} from "../../../route/RouteHelper";
import Recaptcha from "react-google-recaptcha";
import {LoginService} from "../../../connection-services/login/LoginService";
import {ServerErrorHandler} from "../../../service/errorHandler/ServerErrorHandler";
import {
    getLoginPassword,
    getLoginUserName,
    setLoginPassword,
    setLoginUserName
} from "../../../service/localStorage/LocalStorageService";
import {Helmet} from "react-helmet";
import {
    RaikoButtonPrimary,
    RaikoCheckbox,
    RaikoMaterialOutlinedInput,
    RaikoPasswordOutlined,
    showErrorMessage,
    showSuccessMessage,
    showWarningMessage
} from "@moeindal/base-raiko-panel-components";
import {detectServerErrorMessage} from "../../../util/detectServerErrorMessage";

import {css} from "@emotion/css";


export default function SignInEnterPhoneNumber() {
    const service = new LoginService()

    const [loadingButtonState, setLoadingButtonState] = useState(false);

    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [rememberUser, setRememberUser] = useState(false);

    const [error, setError] = useState("");

    const navigate = useNavigate()

    useEffect(() => {
        const _username = getLoginUserName()
        const _password = getLoginPassword()

        if (_username && _username.length > 0 && _password && _password.length > 0) {
            setUsername(_username)
            setPassword(_password)
            setRememberUser(true)
        }

    }, []);

    function validateEnterInfo() {
        if (checkFields()) {
            setLoadingButtonState(true)
            sendSubmitCode("")
            // handleGenerateRecaptcha()
            //     .then(key => {
            //         sendSubmitCode(key)
            //     }).catch(reason => {
            //     showErrorMessage("خطا در اعتبار سنجی کاربر...")
            //     setLoadingButtonState(false)
            // })
        }
    }

    function checkFields() {
        if (username.length > 0 && password.length > 0) {
            return true
        } else {
            showWarningMessage("لطفا نام کاربری و رمز عبور خود را به درستی وارد نمایید.")
            return false
        }
    }

    function goToConfirmCodePage(time) {
        navigate(RouteHelper.SignInEnterSubmitCode.globalUrl, {state: {username, password}, replace: true})
    }

    function sendSubmitCode(key) {
        setLoadingButtonState(true)
        service.sendVerificationCode(username, password, key)
            .then(response => {

                if (response.status === "SENT") {
                    checkForSaveLoginInfo()
                    goToConfirmCodePage(response.time)
                    showSuccessMessage("کد تایید با موفقیت ارسال شد.")
                } else {
                    showErrorMessage("خطا در ارسال پیامک، لطفا کمی صبر کنید و مجددا امتحان نمایید")
                }

            }).catch(reason => {

            if (new ServerErrorHandler(reason).getStatusCode() === 403) {
                showErrorMessage("خطا در اعتبارسنجی کاربر، لطفـا مجددا تلاش نمایید.")
                setRecaptchaGeneratedKey(null)
            } else
                showErrorMessage(detectServerErrorMessage(reason))

        }).finally(_ => {
            setLoadingButtonState(false)
        })
    }

    function checkForSaveLoginInfo() {
        if (rememberUser) {
            setLoginUserName(username)
            setLoginPassword(password)
        }
    }

    const reCaptchaRef = useRef(undefined);
    const [recaptchaGeneratedKey, setRecaptchaGeneratedKey] = useState(null);

    const handleGenerateRecaptcha = () => {
        return new Promise(async (resolve, reject) => {


            if (process.env.REACT_APP_ENABLE_CAPTCHA === "true" || process.env.REACT_APP_ENABLE_CAPTCHA === true) {
                if (recaptchaGeneratedKey) {
                    setRecaptchaGeneratedKey(null)
                    window.grecaptcha.reset();
                }

                let newVar = await reCaptchaRef.current.executeAsync();

                resolve(newVar)
            } else {
                resolve("in developer state captcha not needed !")
            }


        })
    }


    return (
        <>
            <Helmet>
                <title>{RouteHelper.SignInEnterPhoneNumber.name}</title>
            </Helmet>

            <div className={"signInEnterPhoneContainer"}>
                <div className={"pageTitleContainer"}>
                    <img src={signInBanner} alt="ic signin"/>
                    <span className={"title"}>ورود به سامانه</span>
                </div>
                <form className={"signInContentContainer"}>
                    <p className={"signInTitle"}>{`سامانه ی مدیریت ${process.env.REACT_APP_APP_NAME_PERSIAN}`}</p>
                    <span className={"subTitle"}>برای ورود به سامانه نام کاربری و رمز عبور خود را وارد نمایید</span>
                    <RaikoMaterialOutlinedInput
                        labelText={"نام کاربری"}
                        value={username}
                        setValue={setUsername}
                        placeHolder={"نام کاربری خود را وارد نمایید"}
                    />
                    <RaikoPasswordOutlined
                        labelText={"رمز عبور"}
                        value={password}
                        setValue={setPassword}
                        doValidateData={validateEnterInfo}
                        placeHolder={"رمز عبور خود را وارد کنید"}
                    />

                    <RaikoCheckbox
                        label={"من را به خاطر بسپار"}
                        checked={rememberUser}
                        setChecked={setRememberUser}
                    />

                    <Recaptcha
                        ref={reCaptchaRef}
                        className={'g-recaptcha'}
                        sitekey={process.env.REACT_APP_RECAPTCHA_KEY}
                        render={"explicit"}
                        size={"invisible"}
                        onChange={setRecaptchaGeneratedKey}
                        hl={"fa"}
                    />

                    <RaikoButtonPrimary
                        label={"تایید"}
                        onClick={validateEnterInfo}
                        className={css`width: 100%`}
                        loading={loadingButtonState}
                    />

                    <span className={"forgetPassword"}
                          onClick={_ => {
                              navigate(RouteHelper.SignInForgetPassword.globalUrl, {replace: true})
                          }}>فراموشی رمز عبور</span>
                </form>
            </div>
        </>

    )
}